import React, { useState, useEffect } from 'react';
import { FiMenu } from 'react-icons/fi';
import {Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavItem, NavLinks, NavBtn, NavBtnLink, Imgs, StoreItem, StoreImg, StoreButtonWrapper} from './NavbarElements';
// import { Player, Controls } from '@lottiefiles/react-lottie-player';
// import image from '../../images/logo.svg'
import { animateScroll as scroll } from 'react-scroll';
import imgs from '../../images/PacifiedLogo_White.png';
import imgsDark from '../../images/paci-logo.png';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import gplaystore from '../../images/google-play-badge.png';
import applestore from '../../images/downloadonappstore.png';

const  Navbar = ({ toggle, margin, type, lightTheme }) => {

    const[scrollNav, setScrollNav] = useState(false);

    const changeNav = () => {
        if(window.scrollY >= 80) {
            setScrollNav(true);
        }
        else {
            setScrollNav(false)
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', changeNav);
    }, []);

    const toggleHome = () => {
        scroll.scrollToTop();
    };

    return (
        <>
            <Nav scrollNav={scrollNav} margin={margin} lightTheme={lightTheme}>
                <NavbarContainer>
                {/* <Player autoplay loop src="https://assets3.lottiefiles.com/packages/lf20_UJNc2t.json" style={{ height: '100px', width: '100px' }}> */}
                    <NavLogo to="/" onClick={toggleHome}><Imgs src={(scrollNav) ? imgs : (lightTheme ? imgsDark : imgs)}></Imgs></NavLogo>
                    
                        {/* <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
                    </Player> */}
                    <MobileIcon onClick={toggle} lightTheme={lightTheme} scrollNav={scrollNav}>
                        <FiMenu />
                    </MobileIcon>
                    <NavMenu type={type}>
                        <NavItem>
                            <NavLinks to="about" smooth={true} duration={500} spy={true} exact='true' offset={-80} lightTheme={lightTheme} scrollNav={scrollNav}>About</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="discover" smooth={true} duration={500} spy={true} exact='true' offset={-80} lightTheme={lightTheme} scrollNav={scrollNav}>Discover</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="services" smooth={true} duration={500} spy={true} exact='true' offset={-80} lightTheme={lightTheme} scrollNav={scrollNav}>Services</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="contact" smooth={true} duration={500} spy={true} exact='true' offset={-80} lightTheme={lightTheme} scrollNav={scrollNav}>Contact</NavLinks>
                        </NavItem>
                    </NavMenu>
                    <NavBtn>
                        <Popup
                            trigger={<NavBtnLink to="" scrollNav={scrollNav} lightTheme={lightTheme}>Download Pacified® App</NavBtnLink>}
                            modal
                            nested
                            contentStyle={{
                                maxWidth: '420px',
                                width: '90vw',
                                borderRadius: '20px',
                                padding: '32px 24px',
                                boxShadow: '0 20px 80px rgba(0, 0, 0, 0.2)',
                                border: 'none',
                                backgroundColor: '#fff'
                            }}
                            overlayStyle={{
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                backdropFilter: 'blur(8px)'
                            }}
                        >
                            {close => (
                                <div className="modal">
                                    <button
                                        className="close"
                                        onClick={close}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            fontSize: '1.5rem',
                                            position: 'absolute',
                                            top: '16px',
                                            right: '16px',
                                            cursor: 'pointer',
                                            color: '#666',
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f5f5f5';
                                            e.target.style.color = '#333';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = '#666';
                                        }}
                                    >
                                        &times;
                                    </button>
                                    <div style={{
                                        textAlign: 'center',
                                        paddingTop: '16px'
                                    }}>
                                        <h2 style={{
                                            fontSize: '22px',
                                            fontWeight: '600',
                                            color: '#1a1a1a',
                                            marginBottom: '6px',
                                            letterSpacing: '-0.5px'
                                        }}>
                                            Download Pacified® App
                                        </h2>
                                        <p style={{
                                            fontSize: '15px',
                                            color: '#666',
                                            marginBottom: '28px',
                                            lineHeight: '1.4'
                                        }}>
                                            Choose the right pacifier for your baby
                                        </p>
                                        <StoreButtonWrapper>
                                            <StoreItem 
                                                as="a" 
                                                href="https://apps.apple.com/us/app/pacified/id1528971525" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                            >
                                                <StoreImg src={applestore} alt="Download on the App Store" />
                                            </StoreItem>
                                            <StoreItem 
                                                as="a" 
                                                href="https://play.google.com/store/apps/details?id=info.toothprints.pacified" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                            >
                                                <StoreImg src={gplaystore} alt="Get it on Google Play" />
                                            </StoreItem>
                                        </StoreButtonWrapper>
                                    </div>
                                </div>
                            )}
                        </Popup>
                    </NavBtn>
                </NavbarContainer>
            </Nav>
        </>
    );
}

export default Navbar;
